import { WoltLogo, colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';
import UserDropdown from 'modules/header/components/UserDropdown';

const Root = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: 100%;
  height: auto;
  padding: 10px 24px;
  justify-content: space-between;
`;

const StyledWoltLogo = styled(WoltLogo)`
  align-self: center;
  height: 16px;
  fill: ${cssThemedValue({ light: colors.pepper100, dark: colors.salt100 })};
  :hover {
    cursor: pointer;
  }
`;

const OnboardingPageHeader = () => {
  const isMobile = useIsMobile();
  const history = useHistory();

  return (
    <Root isMobile={isMobile}>
      <StyledWoltLogo onClick={() => history.push('/onboarding-page')} />
      <UserDropdown />
    </Root>
  );
};

export default OnboardingPageHeader;
